import { useEffect } from 'react';
import api from '../../utils/functions/api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function subscribeToPush() {
  const registration = await navigator.serviceWorker.ready;
  const { data } = await api.get(`${process.env.REACT_APP_API_URL}/push/vapid-public-key`);
  const applicationServerKey = urlBase64ToUint8Array(data.publicKey);
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey,
  });
  const json = subscription.toJSON();
  await api.post(`${process.env.REACT_APP_API_URL}/push/subscribe`, {
    endpoint: json.endpoint,
    keys: json.keys,
    userAgent: navigator.userAgent,
  });
}

// ไม่มีปุ่มลอยขอเปิดแจ้งเตือนแล้ว — เหลือแค่ลงทะเบียน service worker และต่อ subscription ให้คนที่เคยอนุญาตไว้แล้ว
// (ขออนุญาตเองได้ที่หน้า /profile/permissions ผ่าน subscribeToPush)
export default function PushNotificationSetup() {
  useEffect(() => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

    navigator.serviceWorker
      .register('/service-worker.js')
      .then(async (registration) => {
        if (Notification.permission !== 'granted') return;
        const existing = await registration.pushManager.getSubscription();
        if (existing) {
          const json = existing.toJSON();
          api.post(`${process.env.REACT_APP_API_URL}/push/subscribe`, {
            endpoint: json.endpoint,
            keys: json.keys,
            userAgent: navigator.userAgent,
          }).catch(() => {});
        } else {
          subscribeToPush().catch(() => {});
        }
      })
      .catch(() => {});
  }, []);

  return null;
}
